import { useCallback } from 'react';

import { useRequirementState } from './useRequirementState';
import { Combinator } from '../../types';

export const useRequirementCombinatorState = () => {
  const {
    requirement: {
      searchCombo: { combinator: requirementCombinator } = {},
    },
    setRequirement,
  } = useRequirementState();
  const setRequirementCombinator = useCallback(
    (newCombinator?: Combinator) =>
      setRequirement((requirement) => ({
        ...requirement,
        searchCombo: { searchQueries: [], ...requirement.searchCombo, combinator: newCombinator },
      })),
    [setRequirement],
  );
  return {
    requirementCombinator,
    setRequirementCombinator,
  };
};
